import type { Icons } from '@/components/ui/icon'
import { isIcon } from '@/components/ui/icon'
import type { Icon } from '@/graphql/api'

export const cmsIconToThIcon = (icon: Icon): Icons | undefined => {
    const iconKey = icon.toLowerCase().replace('_', '-')

    if (isIcon(iconKey)) {
        return iconKey
    }

    return undefined
}
